import { render } from "./RuiEye.vue?vue&type=template&id=2a99fef2"
const script = {}
script.render = render

export default script